import { render, staticRenderFns } from "./ConsumptionDataExchangeConfigurationView.vue?vue&type=template&id=440264d8&lang=pug&"
import script from "./ConsumptionDataExchangeConfigurationView.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionDataExchangeConfigurationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports